<!-- <div [ngClass]="className"> -->
<div *ngIf="!isCustomUiChange">
    <h5 mat-dialog-title style="padding:0.2vw; color:black; margin:0 !important">Create Module</h5>
    <mat-divider></mat-divider>
    <div mat-dialog-content style="height: 51vh;
width: 100vh;">
        <mat-card class="user-card" style="width: 93%;">
            <mat-card-content>
                <mat-form-field appearance="outline" class="formfield-half" style="width:50% !important">
                    <mat-label>Module ID</mat-label>
                    <input matInput placeholder="Name" [(ngModel)]="moduleId" (focusin)="clearMessage()" maxlength="50">
                </mat-form-field>
                <mat-form-field appearance="outline" class="formfield-half" style="width:50% !important">
                    <mat-label>Module Name</mat-label>
                    <input matInput placeholder="Name" [(ngModel)]="moduleName" (focusin)="clearMessage()"
                        maxlength="50">
                </mat-form-field>
                <br>
                <mat-form-field appearance="outline" class="formfield-half">
                    <mat-label>Module Item</mat-label>
                    <mat-select [(ngModel)]="selectedModuleItem"
                        (selectionChange)="moduleItemChange(selectedModuleItem)">
                        <mat-option *ngFor="let item of moduleItems" [value]="item.ModuleItemId"
                            style="font-size: 11px;">{{item.ModuleItemName}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>

                <mat-form-field appearance="outline" class="formfield-half">
                    <mat-label>Parent Menu</mat-label>
                    <mat-select [(ngModel)]="selectedParentMenu" [disabled]="!ifSubMenu">
                        <mat-option *ngFor="let parent of parentMenuItems" [value]="parent.ModuleId"
                            style="font-size: 11px;">{{parent.ModuleName}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <br>
                <mat-slide-toggle [(ngModel)]="moduleActive">Active</mat-slide-toggle>
                <br>
                <label style="color: red; font-size: 0.9vw">{{errorMessage}}</label>
            </mat-card-content>
            <mat-card-actions>
                <button mat-raised-button color="primary" (click)="saveModule();">SAVE</button>
                <button mat-raised-button color="primary" (click)="cancelModule();">CANCEL</button>
            </mat-card-actions>
        </mat-card>
    </div>
</div>
<!-- </div> -->


<!-- new CSS chages apply for FEMD and DOM1 -->
<div *ngIf="isCustomUiChange" class="module-create-container">
    <mat-card class="module-create-card">
        <mat-card-header class="module-card-header">
            <mat-card-title class="module-create-title">Create Module</mat-card-title>
            <button mat-icon-button class="module-create-close" (click)="cancelModule()">
                <mat-icon>close</mat-icon>
            </button>
        </mat-card-header>
        <mat-divider></mat-divider>
        <mat-card-content class="module-create-form">
            <mat-form-field appearance="outline" class="module-field-half">
                <mat-label>Module ID</mat-label>
                <input matInput [(ngModel)]="moduleId" maxlength="50" placeholder="Module ID"
                    (focusin)="clearMessage()">
            </mat-form-field>

            <mat-form-field appearance="outline" class="module-field-half">
                <mat-label>Module Name</mat-label>
                <input matInput [(ngModel)]="moduleName" maxlength="50" placeholder="Module Name"
                    (focusin)="clearMessage()">
            </mat-form-field>

            <mat-form-field appearance="outline" class="module-field-half">
                <mat-label>Module Item</mat-label>
                <mat-select [(ngModel)]="selectedModuleItem" (selectionChange)="moduleItemChange(selectedModuleItem)">
                    <mat-option *ngFor="let item of moduleItems" [value]="item.ModuleItemId">
                        {{ item.ModuleItemName }}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" class="module-field-half">
                <mat-label>Parent Menu</mat-label>
                <mat-select [(ngModel)]="selectedParentMenu" [disabled]="!ifSubMenu">
                    <mat-option *ngFor="let parent of parentMenuItems" [value]="parent.ModuleId">
                        {{ parent.ModuleName }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <mat-slide-toggle [(ngModel)]="moduleActive">Active</mat-slide-toggle>
            <label class="module-error-msg">{{ errorMessage }}</label>
        </mat-card-content>

        <mat-card-actions class="module-create-actions">
            <button mat-raised-button color="primary" (click)="saveModule()">SAVE</button>
            <button mat-raised-button color="primary" (click)="cancelModule()">CANCEL</button>
        </mat-card-actions>
    </mat-card>
</div>